import { HttpClient } from "@angular/common/http";
import { Injectable, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Inverter } from "@design/models/inverter.model";
import { PanelArray } from "@design/models/panel-array.model";
import { SimulationResults } from "@design/models/simulation.model";
import { DesignState } from "@design/store/design.reducer";
import { fromInverterActions } from "@design/store/inverter";
import { fromInverterSelectors } from "@design/store/inverter/inverter.selector";
import { NotificationType } from "@lib-ui/lib/atomic/enact-alert-snack-bar/notification.message";
import { openNotificationService } from "@lib-ui/lib/atomic/enact-alert-snack-bar/openNotification.service";
import { ProgressBarVerticalIndicatorComponent } from "@lib-ui/lib/composite/progress-bar-vertical-indicator/progress-bar-vertical-indicator.component";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import saveAs from "file-saver";
import { Observable, of } from "rxjs";
import { take } from "rxjs/operators";
import { AuthService } from "src/app/helpers/auth.service";
import { Utils } from "src/app/helpers/utils";
import { environment } from "src/environments/environment";

@Injectable ({providedIn:'root'})
export class SimulateResultService{
  
  // showInvMismatchWarning = true;

  constructor(private http: HttpClient, private authService: AuthService,private store: Store<DesignState>, 
    private notificationService: openNotificationService, private translate: TranslateService, private router: Router) { }


  returnData(simulationResults:SimulationResults) : Observable<any>{

    return of(simulationResults);

  }

    calculateSize(panelArrays:PanelArray[]) : Observable<any>{
      let systemSize = 0;
      panelArrays.forEach(array=>{
        systemSize = systemSize + ((array.noOfPanelEast + (array.noOfPanelWest ? array.noOfPanelWest : 0)) * array.wattsPerModule);
      });

        const simulationresults :SimulationResults ={
         system_size:systemSize
        }
        return of(simulationresults);
      }
      resetSystemSize(): Observable<SimulationResults>{

        const simulationresults :SimulationResults ={
          system_size: 0,
          storage:0,
          offset:0,
          generation:0,
          // pre_solar_bill:0,
          // post_solar_bill:0,
          // bill_saving:0,
          viewResults:false,
          monthlyGeneration:[],
          postPVAnnualConsumption: 0,
          postPVAnnualBillAmount: 0,
          batteryUages: 0,
          importYear1 : 0,
          exportYear1 :0,
          selfConsumptionSolarOnly : 0,
          selfConsumptionSolarPlusStorage : 0,
          postPVRateArr: []

        }
        return of(simulationresults);
      }
      getBillOffset():Observable<any>{
        return this.http.get(`${String(Utils.getBackendBaseURL())}system-result/bill-offset?qrn=`+localStorage.getItem("qrn")+`&crn=`+localStorage.getItem("crn"));

      }
      quoteMonthlyTiersPostSolar(simulationResults:any, quoteSimulationResults: any):Observable<any>{
        const qrn = this.authService.getItem('qrn', 'localStorage');
        const payload: any = {};
        payload['crn'] = this.authService.getItem('crn', 'localStorage');
        payload['MonthlyGeneration'] = simulationResults.monthlyGeneration?.length ? simulationResults.monthlyGeneration : quoteSimulationResults[qrn]?.systemResults?.monthlyPostSolarConsumption;
        payload['isNEM'] = false;
        payload['qrn'] = qrn
        const apiUrl = `${String(Utils.getBaseurl())}quotes/quoteMonthlyTiersPostSolar`;
        return this.http.post(apiUrl, payload);
      }

      consumptionOverview() :Observable<any>{
        const numberOfMeters = this.authService.getItem('totalMeters', 'localStorage');
        return this.http.get(`${String(environment.newSiteDataApiEndpoint)}system-result/consumption-overview?crn=`+localStorage.getItem("crn")+`&qrn=`+localStorage.getItem("qrn")+`&total_meters=${numberOfMeters}`);

      }

      generationOverview() :Observable<any>{
        const numberOfMeters = this.authService.getItem('totalMeters', 'localStorage');
        return this.http.get(`${String(environment.newSiteDataApiEndpoint)}system-result/generation-overview?crn=` + localStorage.getItem("crn") + `&qrn=` + localStorage.getItem("qrn") + `&total_meters=${numberOfMeters}`);

      }


  updateInverterQuantity(totalSystemSizeDC: number): Observable<any> {
    totalSystemSizeDC = +(totalSystemSizeDC / 1000).toFixed(2);
    const targetCapacity = +(totalSystemSizeDC / 1.2).toFixed(2);
    let selectedInverter: Inverter | any;

    this.store.select(fromInverterSelectors.allInverters).pipe(take(1)).subscribe(data => {

      if (data.length > 0 && data.length == 1) {
        selectedInverter = [...data][0];

        const inverterSize = parseFloat((+selectedInverter.powerRating).toFixed(2)) / 1000;
        const quantity = Math.ceil(targetCapacity / inverterSize);
        selectedInverter = {
          ...selectedInverter,
          quantity: quantity,
          utilizedCapacity: parseFloat((+selectedInverter.powerRating).toFixed(2)) / 1000 * quantity
        };

        let addedACCapacity = selectedInverter.utilizedCapacity;
        addedACCapacity = +addedACCapacity.toFixed(2);
        this.store.dispatch(fromInverterActions.UpdateInverter({ inverter: selectedInverter }));
        const overLimit = !this.validateCapacityRatio(addedACCapacity, targetCapacity, 'inverters');
        this.notificationService.sendMessage({
          message: this.translateMsg('toastrMsgs.invtQuantityUpdate'),
          type: NotificationType.success,
          positionClass: "toast-bottom-left",
          timeOut: 5000
        });
      }
      
    });

    return selectedInverter;
  }
    
  translateMsg(val: any) {
    let translatedName = ''
    this.translate.get(val).pipe(take(1)).subscribe(res => {
      translatedName = res;
    })
    return translatedName;
  }

  getGenerationReportURL(): any {
    const qrn = this.authService.getItem('qrn', 'localStorage');
    const crn = this.authService.getItem('crn', 'localStorage');
    const apiUrl = `${String(environment.s3baseurl)}system-result/generation-report?qrn=${qrn}&crn=${crn}`;
    this.http.get(apiUrl).pipe(take(1)).subscribe((url: any) => {
      if (url && url['data']) {
        return this.downloadGenerationReportData(url['data']);
      }
    }, error => {
      this.notificationService.sendMessage({
        message: this.translateMsg('toastrMsgs.generationDataDwloadedFailed'),
        type: NotificationType.danger,
        positionClass: "toast-bottom-left",
        timeOut: 5000
      });
    });
  }

  downloadGenerationReportData(s3URL: string): any {
    return this.http.get(s3URL, { responseType: 'blob' }).pipe(take(1)).subscribe(data => {
      const project_name = this.authService.getItem('project_name', 'localStorage');
      const quote_id = this.authService.getItem('quote_id', 'localStorage');
      const revision_number = this.authService.getItem('revision_number', 'localStorage');
      const blob = new Blob([data], { type: 'text/csv; charset=utf-8' });
      const fileName = `${project_name && quote_id && revision_number ? project_name.split(/[ ,]+/)?.join('-') + '_' + quote_id + '_' + revision_number + ' ' + this.translateMsg('simRprt') : 'project_nameORqrnORrevisionMissing'}.csv`;
      const file = new File([blob], fileName, { type: 'text/csv; charset=utf-8' });
      saveAs(file);
      this.notificationService.sendMessage({
        message: this.translateMsg('toastrMsgs.generationDataDwloadedSuccess'),
        type: NotificationType.success,
        positionClass: "toast-bottom-left",
        timeOut: 2500
      });
    }, error => {
      throw error;
    })
  }

  validateCapacityRatio(addedCapacity: number, targetCapacity: number, iconIfInverterOnly: string): boolean {
    const lowerLimit = +(Math.round(targetCapacity * 0.9 * 100) / 100).toFixed(2);
    const upperLimit = +(Math.round(targetCapacity * 1.1 * 100) / 100).toFixed(2);

    const isWithinLimit = addedCapacity >= lowerLimit && addedCapacity <= upperLimit;

    if (!isWithinLimit && iconIfInverterOnly === 'inverters' && this.router.url == '/design') {
      this.notificationService.sendMessage({
        message: this.translateMsg('toastrMsgs.addedInvDntMeetTrgtDCACRatio'),
        type: NotificationType.warning,
        positionClass: "toast-bottom-left",
        timeOut: 5000
      });
    }

    return isWithinLimit;
  }

  sum(prev: number, next: number) {
    return prev + next;
  }


  checkAcDcRatioTarget(addedCapacity: number, targetCapacity: number): { quantity: number; addedACCapacity: number, defaultValues: boolean } {

    const inverterSize = parseFloat((+addedCapacity).toFixed(2)) / 1000;
    const quantity = Math.ceil((targetCapacity / inverterSize));
    const total = +((addedCapacity / 1000) * quantity).toFixed(2);
    return { quantity: quantity, addedACCapacity: total, defaultValues: false };
  }
   
}